import React, { useState } from "react"
import { Alert, Button, FormFeedback, FormGroup, FormText, Input, Label, ModalBody } from "reactstrap"
import DraftModal from "./DraftModal"
import { SHIPMENT_WEIGHT_LIMIT, productsWeightOf, shipmentName, statedWeight, weightLabel } from "./shipmentLabels"

// The weight an administrator states after weighing a shipment in preparation, the main one or a supplementary one (US 96, CONTEXT
// „Greutatea expedierii”): kept apart from what its products weigh, it is the weight the validation keeps and where the AWB's parcels
// start. "Use the products' weight" clears it. It is stated outright, without a reason.
export default function ShipmentWeightDialog({ shipment, pending, failure, onSubmit, onClose }) {
  const initial = shipment.setWeight != null ? String(shipment.setWeight) : ""
  const [value, setValue] = useState(initial)
  const weight = statedWeight(value)
  const products = productsWeightOf(shipment)
  return <DraftModal id="logistics-weight-title" title={`Shipment weight — ${shipmentName(shipment)}`} dirty={value !== initial} onClose={onClose}
    actions={<>
      {shipment.setWeight != null && <Button color="light" className="mr-2" disabled={pending}
        onClick={() => onSubmit({ action: "setShipmentWeight", weight: null })}>Use the products' weight</Button>}
      <Button color="primary" disabled={pending || weight == null} onClick={() => onSubmit({ action: "setShipmentWeight", weight })}>
        {pending ? "Saving…" : "Save"}
      </Button>
    </>}>
    <ModalBody>
      <p className="small">{products != null ? `The products weigh ${weightLabel(products)}, without the shipping packages.`
        : "The products have no unit weight."} Weigh the packed parcels and state their total weight here.</p>
      <FormGroup className="mb-0">
        <Label for="logistics-weight">Weight after weighing (kg)<span className="text-danger"> *</span></Label>
        <Input id="logistics-weight" type="number" min="0.01" max={SHIPMENT_WEIGHT_LIMIT} step="0.01" value={value} invalid={value.trim() !== "" && weight == null}
          onChange={event => setValue(event.target.value)} />
        <FormFeedback>{`Enter a weight from 0.01 to ${SHIPMENT_WEIGHT_LIMIT} kg.`}</FormFeedback>
        <FormText>It replaces the products' weight at the processing, and the AWB's parcels start from it.</FormText>
      </FormGroup>
      {failure && <Alert color="danger" className="mt-3 mb-0">{failure}</Alert>}
    </ModalBody>
  </DraftModal>
}
